import { format } from "date-fns";
import { useSelector } from "react-redux";
import { getUserPreferences } from "selectors/commonSelectors";
import { MessageType } from "types/conversationInbox";
import { getDateFormat } from "../components/date-format";
import { AccountMessageProps } from "../message/account-message";
import { DateLabel as DateLabelTag } from "../message/styled";
import { UnknownUserInfoIcon } from "@inbox/shared/common-styles";

type Props = Pick<
  AccountMessageProps,
  "type" | "userName" | "timestamp" | "shouldDisplaySender" | "forceLeft"
> & {
  isUnknownUser?: boolean;
};

export function useFormatMessageDateTime(timestamp: Date): string {
  const preferences = useSelector(getUserPreferences);
  const messageDateFormat = getDateFormat(preferences);
  try {
    const date = format(timestamp, messageDateFormat);
    return date;
  } catch {
    return "";
  }
}

export function DateLabel({
  type,
  userName,
  timestamp,
  shouldDisplaySender,
  forceLeft,
  isUnknownUser,
}: Props): JSX.Element {
  const date = useFormatMessageDateTime(timestamp);

  shouldDisplaySender =
    shouldDisplaySender &&
    ![
      MessageType.igMention,
      MessageType.igStoryReply,
      MessageType.igStoryMention,
    ].includes(type);

  return (
    <DateLabelTag left={forceLeft} data-testid="date-label">
      {shouldDisplaySender && isUnknownUser ? (
        <>
          {userName}
          <UnknownUserInfoIcon className="mx-1" /> at&nbsp;
        </>
      ) : shouldDisplaySender ? (
        `${userName} at `
      ) : null}
      {date}
    </DateLabelTag>
  );
}
